import DeleteIcon from '@material-ui/icons/Delete';
import { useApi, useRouteRef } from '@backstage/core-plugin-api';
import {
  createFrontendModule,
  dialogApiRef,
} from '@backstage/frontend-plugin-api';
import { useEntity } from '@backstage/plugin-catalog-react';
import {
  EntityContextMenuItemBlueprint,
  useEntityPermission,
} from '@backstage/plugin-catalog-react/alpha';
import { catalogEntityDeletePermission } from '@backstage/plugin-catalog-common/alpha';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { useNavigate } from 'react-router-dom';
import { DeleteCatalogDialog } from './DeleteCatalogDialog';

export const deleteCatalogIcon = <DeleteIcon fontSize="small" />;

export function useDeleteCatalogMenuProps() {
  const { entity } = useEntity();
  const dialogApi = useApi(dialogApiRef);
  const permission = useEntityPermission(catalogEntityDeletePermission);
  const navigate = useNavigate();
  const catalogRoute = useRouteRef(catalogPlugin.routes.catalogIndex);
  return {
    title: 'Delete catalog',
    disabled: !permission.allowed,
    onClick: async () => {
      dialogApi.open(({ dialog }) => (
        <DeleteCatalogDialog
          entity={entity}
          onClose={() => dialog.close()}
          onConfirm={() => {
            dialog.close();
            navigate(catalogRoute());
          }}
        />
      ));
    },
  };
}

export const deleteCatalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    EntityContextMenuItemBlueprint.make({
      name: 'delete-catalog',
      params: {
        icon: deleteCatalogIcon,
        useProps: useDeleteCatalogMenuProps,
      },
    }),
  ],
});
